import React, { useContext, useReducer, useMemo, useEffect } from 'react'
import Table, { TableHook } from '../../Table';
import { Box, IconButton, Tooltip } from '@mui/material';
import { api } from '../../../services/api';
import { lockedReducer } from '../../Utils/reducers';
import EditClientesDesconsiderados from './edit';
import DeleteIcon from '@mui/icons-material/Delete';
import clsx from 'clsx';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditIcon from '@mui/icons-material/Edit';

const url = 'clientes_desconsiderados'

const columns = (setState) => {
    const columns = []
    columns.push({ field: 'nome_cliente', headerName: 'Cliente', width: 350, cellClassName: () => { return clsx('center', { selected: true, }); } })
    columns.push({ field: 'nome_empresa', headerName: 'Empresa', flex: 0.9, cellClassName: () => { return clsx('center', { selected: true, }); } })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 150,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Editar tabela'><IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton></Tooltip>
                    <Tooltip title='Deleta tabela'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>
                </Box>
            )
        }
    })
    return columns
}

const deleteClient = async (setLoader, setState, getClients, id) => {
    setLoader(true)
    const res = await api.post(`/${url}/${id}`)
    if (res.status === 200) {
        await getClients(setLoader, setState)
        setState({ deleteRow: null })
    }
    setLoader(false)
}

const getClientsDisregarded = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(`/${url}/`)
    if (res.status === 200) {
        setState({ rows: res.data })
    }
    setLoader(false)
}

const ClientesDesconsiderados = () => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        deleteRow: null
    })

    const [table] = TableHook()

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        getClientsDisregarded(setLoader, setState)
    }, [])

    return (
        <>

            {
                state.editRow &&

                <EditClientesDesconsiderados
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={() => getClientsDisregarded(setLoader, setState)}
                />

            }

            {
                state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o cliente ${state.deleteRow.nome_cliente} ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => deleteClient(setLoader, setState, getClientsDisregarded, state.deleteRow.id)}
                />

            }

            <Box  sx={{ height: '100%', overflow:'hidden' }}>

                <Table
                    paginationMode='client'
                    className='contabil-grid'
                    rows={state.rows}
                    columns={useMemo(() => columns(setState), [state.rows, state.edit])}
                    pagination={false}
                    toolbar
                    slots={{
                        addComponent: () => setState({ editRow: {} })
                    }}
                    rowHeight={30}
                    innerRef={table}
                    sx={{ height: '100%' }}
                />

            </Box>

        </>
    )
}

export default ClientesDesconsiderados;